import React, { useEffect, useState } from 'react';
import { getStaffLicenseExpiration } from "../../../services/widgetsService";
 
function LicenseExpirationWidget() {
  const [staff, setStaff] = useState([]);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');

  const getStaffLicenseExpirationData = async () => {
    const { data } = await getStaffLicenseExpiration();
    setStaff(data.staff);
    setTitle(data.title);
    setText(data.text);
  }

  useEffect(() => {
    getStaffLicenseExpirationData();
  }, []);

  return (
    <div>
      { staff.length === 0
        ? ''
        : <div className="col-auto">    
          <div className='DashboardList-item btn d-flex flex-column'>
            <h4><i className="far fa-id-badge"></i>&nbsp;{title}</h4>
            <p>{text}</p>
            <ul>
            { staff.map( (item, idx) => (
                <li key={idx}><a href={"staff/" + item.id}>{item.first_name} {item.last_name} - {item.department} - {item.security_license_date}</a></li>
              ) )
            }
            </ul>
          </div>
        </div>
      }
    </div>
  )
}

export default LicenseExpirationWidget;